exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li[data-v-1d65cbe0]{margin-bottom:0!important}.is-selected[data-v-1d65cbe0]{background-color:var(--cyan-light-4)}", ""]);

// exports
